export default {
  '2xSmallRegular': {
    fontFamily: 'Nunito-Regular',
    fontSize: '10px',
    lineHeight: `${14}px`,
  },
  '2xSmallSemiBold': {
    fontFamily: 'Nunito-SemiBold',
    fontSize: '10px',
    lineHeight: `${14}px`,
  },
  '2xSmallBold': {
    fontFamily: 'Nunito-Bold',
    fontSize: '10px',
    lineHeight: `${14}px`,
  },
  xSmallRegular: {
    fontFamily: 'Nunito-Regular',
    fontSize: '12px',
    lineHeight: `${18}px`,
  },
  xSmallSemiBold: {
    fontFamily: 'Nunito-SemiBold',
    fontSize: '12px',
    lineHeight: `${18}px`,
  },
  xSmallBold: {
    fontFamily: 'Nunito-Bold',
    fontSize: '12px',
    lineHeight: `${18}px`,
  },
  smallRegular: {
    fontFamily: 'Nunito-Regular',
    fontSize: '14px',
    lineHeight: `${20}px`,
  },
  smallSemiBold: {
    fontFamily: 'Nunito-SemiBold',
    fontSize: '14px',
    lineHeight: `${20}px`,
  },
  smallBold: {
    fontFamily: 'Nunito-Bold',
    fontSize: '14px',
    lineHeight: `${20}px`,
  },
  mediumRegular: {
    fontFamily: 'Nunito-Regular',
    fontSize: '16px',
    lineHeight: `${22}px`,
  },
  mediumSemiBold: {
    fontFamily: 'Nunito-SemiBold',
    fontSize: '16px',
    lineHeight: `${22}px`,
  },
  mediumBold: {
    fontFamily: 'Nunito-Bold',
    fontSize: '16px',
    lineHeight: `${22}px`,
  },
  largeRegular: {
    fontFamily: 'Nunito-Regular',
    fontSize: '18px',
    lineHeight: `${24}px`,
  },
  largeSemiBold: {
    fontFamily: 'Nunito-SemiBold',
    fontSize: '18px',
    lineHeight: `${24}px`,
  },
  largeBold: {
    fontFamily: 'Nunito-Bold',
    fontSize: '18px',
    lineHeight: `${24}px`,
  },
  xLargeRegular: {
    fontFamily: 'Nunito-Regular',
    fontSize: '20px',
    lineHeight: `${26}px`,
  },
  xLargeSemiBold: {
    fontFamily: 'Nunito-SemiBold',
    fontSize: '20px',
    lineHeight: `${26}px`,
  },
  xLargeBold: {
    fontFamily: 'Nunito-Bold',
    fontSize: '20px',
    lineHeight: `${26}px`,
  },
  '2xLargeRegular': {
    fontFamily: 'Nunito-Regular',
    fontSize: '24px',
    lineHeight: `${32}px`,
  },
  '2xLargeSemiBold': {
    fontFamily: 'Nunito-SemiBold',
    fontSize: '24px',
    lineHeight: `${32}px`,
  },
  '2xLargeBold': {
    fontFamily: 'Nunito-Bold',
    fontSize: '24px',
    lineHeight: `${32}px`,
  },
  '3xLargeRegular': {
    fontFamily: 'Nunito-Regular',
    fontSize: '28px',
    lineHeight: `${36}px`,
  },
  '3xLargeSemiBold': {
    fontFamily: 'Nunito-SemiBold',
    fontSize: '28px',
    lineHeight: `${36}px`,
  },
  '3xLargeBold': {
    fontFamily: 'Nunito-Bold',
    fontSize: '28px',
    lineHeight: `${36}px`,
  },
  '4xLargeRegular': {
    fontFamily: 'Nunito-Regular',
    fontSize: '36px',
    lineHeight: `${50}px`,
  },
  '4xLargeSemiBold': {
    fontFamily: 'Nunito-SemiBold',
    fontSize: '36px',
    lineHeight: `${50}px`,
  },
  '4xLargeBold': {
    fontFamily: 'Nunito-Bold',
    fontSize: '36px',
    lineHeight: `${50}px`,
  },
  '5xLargeRegular': {
    fontFamily: 'Nunito-Regular',
    fontSize: '48px',
    lineHeight: `${64}px`,
  },
  '5xLargeSemiBold': {
    fontFamily: 'Nunito-SemiBold',
    fontSize: '48px',
    lineHeight: `${64}px`,
  },
  '5xLargeBold': {
    fontFamily: 'Nunito-Bold',
    fontSize: '48px',
    lineHeight: `${64}px`,
  },
  '6xLargeRegular': {
    fontFamily: 'Nunito-Regular',
    fontSize: '64px',
    lineHeight: `${84}px`,
  },
  '6xLargeSemiBold': {
    fontFamily: 'Nunito-SemiBold',
    fontSize: '64px',
    lineHeight: `${84}px`,
  },
  '6xLargeBold': {
    fontFamily: 'Nunito-Bold',
    fontSize: '64px',
    lineHeight: `${84}px`,
  },
};
